module.exports = __webpack_public_path__ + "img/bg_4.af2fc9a9.jpeg";